<nz-page-header nzTitle="Workflow Role List"></nz-page-header>

<button nz-button nzType="dashed" class="mb-1" (click)="add()">+ Add Workflow Role</button>

<nz-table nzSize="small" [nzData]="data" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Workflow</th>
			<th>Name</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="openWorkflowRole(item)">
			<td>{{item.workflow!.label}}</td>
			<td>{{item.name}}</td>
			<td>{{item.description}}</td>
		</tr>
	</tbody>
</nz-table>
